import { Modal, Form, Button } from 'react-bootstrap';

const QuickAddSubtasksModal = ({
    show,
    onHide,
    subtasksList,
    setSubtasksList,
    onSubmit
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Quickly Add Subtasks</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Enter Subtasks <span className='text-danger'>*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={10}
                            value={subtasksList}
                            onChange={(e) => setSubtasksList(e.target.value)}
                            placeholder="Design login page&#10;Implement authentication&#10;Add form validation"
                        />
                        <Form.Text className="p-tag fs-12 mt-2">
                            Enter each subtask on a new line. Empty lines will be ignored.
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onSubmit}>
                    Add Subtasks
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QuickAddSubtasksModal;
